import { render, staticRenderFns } from "./DeportesTable.view.vue?vue&type=template&id=47c92062&scoped=true"
import script from "./DeportesTable.view.vue?vue&type=script&lang=js"
export * from "./DeportesTable.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c92062",
  null
  
)

export default component.exports